import React from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { OptionValue } from '../../services/types/Misc';

interface Props {
  size?: string;
  txtSize?: number;
  className?: string;
  icon?: IconProp;
  elements: OptionValue[];
  value: number | null;
  onChange: (value: number) => void;
}

const DropDown: React.FC<Props> = ({
  size,
  className,
  icon,
  elements,
  value,
  onChange,
  txtSize,
}) => {
  const drawItem = (opt: OptionValue) => {
    const active = opt.id === value;
    return (
      <DropdownItem key={opt.id} onClick={() => onChange(opt.id)} active={active}>
        {opt.text} {active && <FontAwesomeIcon icon="check" />}
      </DropdownItem>
    );
  };

  const selectedText = () => {
    const obj = elements.find((x) => x.id === value);
    return obj ? obj.text : null;
  };

  const classes = `${className || ''} ${icon ? 'icon' : ''}`;

  return (
    <UncontrolledDropdown size={size} className={classes}>
      <DropdownToggle className={icon ? 'icon' : ''} outline color="primary">
        <p>
          {icon && <FontAwesomeIcon icon={icon} />}
          <span className={txtSize ? `wd${txtSize}` : ''}>{selectedText()}</span>
          <span className="mr-auto" />
          <FontAwesomeIcon icon="chevron-down" />
        </p>
      </DropdownToggle>
      <DropdownMenu className="dropdown__menu">{elements.map((e) => drawItem(e))}</DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default DropDown;
